import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "mainItems"];
import React from "react";
import Link from "next/link";
import { Button } from "../button";
import { Top } from "./top";
import { Menu } from "./menu";
import { Disclosure, Transition } from "@headlessui/react";
import { MobileMenu } from "./mobile_menu";
import { Search } from "../search";
import Logo from "./Logo";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CancerqldNav = props => {
  var {
    mainItems = []
  } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  return /*#__PURE__*/_jsxs("nav", _extends({}, rest, {
    className: "grid gap-4",
    children: [/*#__PURE__*/_jsx(Top, {}), /*#__PURE__*/_jsxs(Disclosure, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: "w-full flex flex-wrap gap-4 items-center justify-between max-w-7xl w-full mx-auto px-4 py-2",
        children: [/*#__PURE__*/_jsx(Link, {
          href: "/",
          children: /*#__PURE__*/_jsxs("a", {
            className: "max-w-[8rem] h-14 md:h-24 md:max-w-none",
            children: [/*#__PURE__*/_jsx("span", {
              className: "sr-only",
              children: "Logo"
            }), /*#__PURE__*/_jsx(Logo, {})]
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "grid   grid-cols-2 items-center md:hidden",
          children: [/*#__PURE__*/_jsx(Search, {
            children: /*#__PURE__*/_jsx("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              className: "h-6 w-6 stroke-ccq-dark-blue mx-auto",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor",
              strokeWidth: 2,
              children: /*#__PURE__*/_jsx("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              })
            })
          }), /*#__PURE__*/_jsx(Disclosure.Button, {
            as: React.Fragment,
            children: /*#__PURE__*/_jsx(Button, {
              color: "transparent",
              children: /*#__PURE__*/_jsxs("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: "h-6 w-6",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                strokeWidth: 2,
                children: [/*#__PURE__*/_jsx("title", {
                  children: "Menu"
                }), /*#__PURE__*/_jsx("path", {
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  d: "M4 6h16M4 12h16M4 18h16"
                })]
              })
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "grid items-center gap-4 w-full md:max-w-[70%] grid-cols-2 md:grid-cols-5 shrink",
          children: [/*#__PURE__*/_jsx(Button, {
            className: "border",
            href: "tel:13 11 20",
            color: "transparent",
            children: "13 11 20"
          }), /*#__PURE__*/_jsx(Button, {
            href: "tel:13 11 20",
            color: "primary",
            children: "Call us"
          }), /*#__PURE__*/_jsx(Button, {
            href: "/chat",
            color: "secondary",
            children: "Chat online"
          }), /*#__PURE__*/_jsx(Button, {
            href: "/donate",
            color: "tertiary",
            children: "Donate"
          }), /*#__PURE__*/_jsx(Search, {
            className: "hidden md:flex"
          })]
        })]
      }), /*#__PURE__*/_jsx(Menu, {
        mainItems: mainItems
      }), /*#__PURE__*/_jsx(Transition, {
        enter: "transition duration-100 ease-out",
        enterFrom: "transform scale-95 opacity-0",
        enterTo: "transform scale-100 opacity-100",
        leave: "transition duration-75 ease-out",
        leaveFrom: "transform scale-100 opacity-100",
        leaveTo: "transform scale-95 opacity-0",
        children: /*#__PURE__*/_jsx(Disclosure.Panel, {
          children: /*#__PURE__*/_jsx(MobileMenu, {
            mainItems: mainItems
          })
        })
      })]
    })]
  }));
};
//# sourceMappingURL=index.js.map